var _path, _path2, _path3, _circle, _path4, _circle2, _path5, _path6, _circle3, _g, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 689,
    height: 120,
    viewBox: "0 0 689 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.925 49.5798L221.849 60.5042L210.925 71.4286M195.631 49.5798L206.555 60.5042L195.631 71.4286",
    stroke: "#70D44B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M494.286 49.5798L505.211 60.5042L494.286 71.4286M478.992 49.5798L489.917 60.5042L478.992 71.4286",
    stroke: "#70D44B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M404.37 60C404.37 93.1371 377.507 120 344.37 120C311.233 120 284.37 93.1371 284.37 60C284.37 26.8629 311.233 0 344.37 0C377.507 0 404.37 26.8629 404.37 60Z",
    fill: "#70D44B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 344.37,
    cy: 59.9999,
    r: 51.4328,
    stroke: "white",
    strokeDasharray: "5 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60Z",
    fill: "#70D44B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0002,
    cy: 59.9999,
    r: 51.4328,
    stroke: "white",
    strokeDasharray: "5 5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5789 64.0757V43.792C83.5789 37.813 83.5789 34.8236 82.5509 32.5399C81.6467 30.5312 80.2038 28.898 78.4292 27.8745C76.4116 26.7109 73.7706 26.7109 68.4884 26.7109H48.3678C43.0856 26.7109 40.4446 26.7109 38.4271 27.8745C36.6524 28.898 35.2096 30.5312 34.3053 32.5399C33.2773 34.8236 33.2773 37.813 33.2773 43.792V80.8008C33.2773 86.7798 33.2773 89.7692 34.3053 92.0529C35.2096 94.0616 36.6524 95.6948 38.4271 96.7183C40.4446 97.8819 43.0856 97.8819 48.3678 97.8819H58.4281M64.7158 58.7379H45.8527M52.1404 72.972H45.8527M71.0035 44.5037H45.8527M66.2877 87.2062L72.5754 94.3233L86.7227 78.3099",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M688.739 60C688.739 93.1371 661.876 120 628.739 120C595.602 120 568.739 93.1371 568.739 60C568.739 26.8629 595.602 0 628.739 0C661.876 0 688.739 26.8629 688.739 60Z",
    fill: "#70D44B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.739,
    cy: 59.9999,
    r: 51.4328,
    stroke: "white",
    strokeDasharray: "5 5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.289 71.8346C348.774 75.3197 348.912 79.8281 346.45 82.2898L353.42 89.2599L388.271 54.4094L381.301 47.4392C378.977 49.7626 374.331 49.7626 370.846 46.2776C367.361 42.7925 367.361 38.1458 369.684 35.8224L362.714 28.8523L346.45 45.1159",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.38 49.9812C324.908 50.4529 324.13 50.4477 323.663 49.9813C323.19 49.508 323.19 48.7384 323.663 48.2651C324.137 47.7919 324.906 47.7919 325.38 48.2651C325.846 48.7316 325.851 49.5096 325.38 49.9812Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.945 53.5467C328.473 54.0183 327.695 54.0131 327.229 53.5467C326.756 53.0735 326.756 52.3038 327.229 51.8306C327.702 51.3573 328.472 51.3573 328.945 51.8305C329.411 52.297 329.417 53.075 328.945 53.5467Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.51 57.1119C332.039 57.5835 331.261 57.5783 330.794 57.1119C330.321 56.6387 330.321 55.869 330.794 55.3957C331.267 54.9225 332.037 54.9225 332.51 55.3957C332.977 55.8622 332.982 56.6402 332.51 57.1119Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.158 60.5818C335.686 61.0535 334.908 61.0483 334.442 60.5818C333.969 60.1086 333.969 59.3389 334.442 58.8657C334.915 58.3925 335.685 58.3925 336.158 58.8657C336.624 59.3322 336.629 60.1102 336.158 60.5818Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.723 64.147C339.252 64.6187 338.474 64.6135 338.007 64.147C337.534 63.6738 337.534 62.9041 338.007 62.4309C338.48 61.9577 339.25 61.9577 339.723 62.4309C340.19 62.8973 340.195 63.6754 339.723 64.147Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.289 67.7122C342.817 68.1838 342.039 68.1787 341.573 67.7122C341.099 67.239 341.099 66.4693 341.573 65.9961C342.046 65.5229 342.816 65.5229 343.289 65.9961C343.755 66.4625 343.76 67.2406 343.289 67.7122Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.026 88.0983L322.056 81.1282C324.517 78.6664 324.379 74.1581 320.894 70.673C317.409 67.1879 312.901 67.0496 310.439 69.5113L303.469 62.5412L338.319 27.6907L345.289 34.6608C342.966 36.9842 342.966 41.6309 346.451 45.1159C349.936 48.601 354.583 48.601 356.906 46.2776L363.876 53.2477L329.026 88.0983Z",
    stroke: "white",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.967 65.573C363.496 66.0447 362.718 66.0395 362.251 65.5731C361.778 65.0998 361.778 64.3302 362.251 63.8569C362.725 63.3837 363.494 63.3837 363.967 63.8569C364.434 64.3234 364.439 65.1014 363.967 65.573Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.532 69.1385C367.06 69.6101 366.282 69.6049 365.816 69.1385C365.343 68.6653 365.343 67.8956 365.816 67.4224C366.289 66.9491 367.059 66.9491 367.532 67.4223C367.998 67.8888 368.004 68.6668 367.532 69.1385Z",
    stroke: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M653.414 54.233C651.89 38.8903 641.248 29.5586 628.739 29.5586C616.916 29.5586 609.301 37.8177 606.806 46.0082C596.525 47.0363 587.615 53.4773 587.615 65.1993C587.615 76.5084 596.868 84.3905 608.177 84.3905H652.728C662.152 84.3905 669.863 79.6887 669.863 69.3117C669.863 59.0616 660.782 54.6168 653.414 54.233Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M633.954 67.4388C632.378 65.87 630.343 65.0034 628.236 65.0034C626.128 65.0034 624.093 65.87 622.518 67.4388",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M638.523 62.3193C635.733 59.3963 632.055 57.7703 628.235 57.7703C624.415 57.7703 620.738 59.3963 617.947 62.3193",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M642.584 56.6661C638.635 52.7193 633.528 50.5381 628.236 50.5381C622.943 50.5381 617.836 52.7193 613.887 56.6661",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M628.235 76.2765C627.761 76.2765 627.298 76.1191 626.904 75.8243C626.51 75.5295 626.203 75.1104 626.022 74.6202C625.841 74.1299 625.793 73.5905 625.886 73.07C625.978 72.5495 626.206 72.0715 626.541 71.6962C626.876 71.321 627.303 71.0655 627.768 70.962C628.232 70.8584 628.714 70.9116 629.151 71.1146C629.589 71.3177 629.963 71.6616 630.226 72.1028C630.489 72.544 630.63 73.0628 630.63 73.5934C630.63 74.305 630.377 74.9875 629.928 75.4906C629.479 75.9938 628.87 76.2765 628.235 76.2765Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.8578,
    height: 78.8578,
    fill: "white",
    transform: "translate(345.289 2.13354) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcons);
export default __webpack_public_path__ + "static/media/group_icons.d99c88a984ad20fa024b2038d0613371.svg";
export { ForwardRef as ReactComponent };